export const LOAD_ASSIGNED_TENDERS_TABLE_DATA = 'LOAD_ASSIGNED_TENDERS_TABLE_DATA'
export const LOAD_ASSIGNED_TENDERS_TABLE_DATA_REQUEST = (id) => `LOAD_ASSIGNED_TENDERS_TABLE_${id}_DATA_REQUEST`
export const ASSIGNED_TENDERS_TABLE_LOADING_TRUE = 'ASSIGNED_TENDERS_TABLE_LOADING_TRUE'
export const ASSIGNED_TENDERS_TABLE_LOADING_FALSE = 'ASSIGNED_TENDERS_TABLE_LOADING_FALSE'
export const ASSIGNED_TENDERS_TABLE_LOADING_FAILED = 'ASSIGNED_TENDERS_TABLE_LOADING_FAILED'
export const ASSIGNED_TENDERS_TABLE_DATA_RECEIVED = 'ASSIGNED_TENDERS_TABLE_DATA_RECEIVED'
